import useGameReviewBase from './useGameReviewBase';

const useWheelOfFortuneReview = (activityFormData) => {
  const baseReview = useGameReviewBase(activityFormData);
  const {displayConfig} = baseReview;

  const gameConfig = displayConfig?.gameConfig || {};
  const wheelSlices = gameConfig?.wheelSlices || [];

  const slices = displayConfig?.slices || wheelSlices.length || 5;
  const equalProbability =
    gameConfig?.equalProbabilityPerSlice ??
    displayConfig?.equalProbability ??
    true;
  const equalPoints =
    gameConfig?.equalPointsPerSlice ?? displayConfig?.equalPoints ?? true;

  // Extract probabilities and points from wheelSlices array
  const sliceProbabilities =
    wheelSlices.length > 0
      ? wheelSlices.map((slice) => slice.probability || 0)
      : displayConfig?.sliceProbabilities || [];
  const slicePoints =
    wheelSlices.length > 0
      ? wheelSlices.map((slice) => slice.rewardPoints || 0)
      : displayConfig?.slicePoints || [];

  // Derive language codes from quiz question translations since
  // activityFormData.translations is empty on the review screen
  const quizQuestions = activityFormData?.wofQuizQuestions?.data || [];
  const quizLanguageCodes = [
    ...new Set(quizQuestions.flatMap((q) => Object.keys(q.translations || {})))
  ];

  return {
    ...baseReview,
    slices,
    equalProbability,
    equalPoints,
    sliceProbabilities,
    slicePoints,
    quizLanguageCodes
  };
};

export default useWheelOfFortuneReview;
